import { SafeParseError } from 'zod';
import { ZodParseError } from 'libs/end-to-end/src/types/errors/zod-parse-error';

export const createZodParseError = <Input>(
  safeParseResult: SafeParseError<Input>,
): ZodParseError => ({
  errorType: 'ZodParseError',
  errorReason: safeParseResult.error.message,
});
